import PopupTemplate from '@arcgis/core/PopupTemplate';
import ActionButton from '@arcgis/core/support/actions/ActionButton';
import { buildSurfaceLotsUrl } from '../config/eventParkingConfig';

/**
 * Creates the popup template used for surface parking lot features.
 * Shows the lot name, lot number, stall count, and a thumbnail image when available.
 * Includes a Directions action that opens Google Maps driving directions to the lot.
 */
export const createParkingLotPopupTemplate = () => {
  const directionsAction = new ActionButton({
    title: 'Directions',
    id: 'directions-action',
    icon: 'compass',
  });

  return new PopupTemplate({
    actions: [directionsAction] as any,
    title: '{LOTNAME}',
    content: async (feature: any) => {
      const attributes = feature.graphic.attributes || {};
      const lotName = attributes.LOTNAME as string;
      const lotNumber = attributes.LOTNUMBER as string;
      const stallCount = attributes.StallCount as number;

      // const lotNumMatch = lotNumber?.match(/\d+/);
      // const lotNum = lotNumMatch ? lotNumMatch[0].padStart(3, '0') : '000';
      // const thumbnailUrl = `${window.location.origin}/app/resources/lotthumbnails/Lot${lotNum}.jpg`;
      const thumbnailUrl = `${buildSurfaceLotsUrl()}/${attributes.OBJECTID}/attachments/${attributes.thumbnail}`;
      let shouldRenderThumbnail = false;

      // Verify the attachment exists and is an image before rendering it
      try {
        const thumbnailResponse = await fetch(thumbnailUrl, { method: 'HEAD' });
        const contentType = thumbnailResponse.headers.get('content-type') ?? '';
        shouldRenderThumbnail = thumbnailResponse.ok && contentType.toLowerCase().startsWith('image/');
      } catch {
        shouldRenderThumbnail = false;
      }

      const thumbnailMarkup = shouldRenderThumbnail
        ? `<img src="${thumbnailUrl}" alt="${lotName}" style="width: 100%; height: auto; border-radius: 4px;" />`
        : '';

      return `
        ${thumbnailMarkup}
        <div style="padding: 10px;">
          <h2>${lotName}</h2>
          <p><strong>Lot Number:</strong> ${lotNumber}</p>
          <p><strong>Stall Count:</strong> ${stallCount || 'N/A'}</p>
          <div style="margin-top: 10px;"></div>
        </div>
      `;
    },
  });
};

export default createParkingLotPopupTemplate;
